import { createSlice } from '@reduxjs/toolkit';

export enum SidePanelModes {
  GEOGEBRA = 'geogebra',
  NOTES = 'notes',
  NONE = 'none',
  GROUPS = 'groups',
  DIFFERENTIATION = 'differentiation',
  DASHBOARD = 'dashboard',
  GROUP_NOTES = 'groupnotes',
  TRAINER_FORM = 'trainerform',
  MANUAL = 'manual',
  TEACHER_BOOKMARK = 'teacher_bookmark',
  NEWS = 'news',
}

export interface Dimensions {
  width?: number;
  height?: number | string;
}

export interface SidePanelState {
  sidepanel?: Dimensions;
  isOpen?: boolean;
  sidePanelMode?: SidePanelModes;
}

const initialState: SidePanelState = {
  sidepanel: {
    width: 0,
    height: '100%',
  },
  isOpen: false,
  sidePanelMode: undefined,
};

export const sidePanelSlice = createSlice({
  name: 'sidePanelSlice',
  initialState,
  reducers: {
    changeSidepanelDimensions: (state, action) => {
      state.sidepanel = action.payload;
    },
    changeSidepanelWidth: (state, action) => {
      if (state.sidepanel) state.sidepanel.width = action.payload;
    },
    openSidePanel: (state, action) => {
      state.sidepanel = { ...state.sidepanel, width: action.payload ? 320 : 0 };

      state.isOpen = action.payload;
    },
    changePanelContent: (state, action) => {
      state.sidePanelMode = action.payload;
    },
  },
});

export const {
  changeSidepanelDimensions,
  changeSidepanelWidth,
  openSidePanel,
  changePanelContent,
} = sidePanelSlice.actions;

export const { reducer: sidePanelReducer } = sidePanelSlice;
